module.exports = __webpack_public_path__ + "h5/img/unionpay-logo.f03c8924.png";